






















import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { Department, DepartmentGroup } from "../../../../../../domain/department";
import { ClaioSchemaItem, ClaioSchemaGroup } from "../../../../../../domain/claio";
import { DomainRegistry } from "../../../../../../domain";
import { ModelEditableMixin } from "../../../../../system/mixins";
import DepartmentDropDownSelector from "../../../../../department/selectors/DepartmentDropDownSelector.vue";
import OptionDropDownSelector from "../../../../../system/selectors/OptionDropDownSelector.vue";
import { StandardOption } from "../../../../../system/selectors/mixins";

@Component({
  components: {
    departmentSelector: DepartmentDropDownSelector,
    optionDropDownSelector: OptionDropDownSelector,
  }
})
export default class ClaioSchemaFinder extends Mixins(ModelEditableMixin) {
  editingSource: ClaioSchemaItem[];

  data(): any {
    return {
      selectedDepartment: null as Department,
      selectedGroup: null as StandardOption<ClaioSchemaGroup>,
      groups: [] as StandardOption<ClaioSchemaGroup>[],
      isInitialized: false,
    };
  }
  selectedDepartment: Department;
  selectedGroup: ClaioSchemaGroup;
  groups: StandardOption<ClaioSchemaGroup>[];
  isInitialized: boolean;

  mounted() {
    if (this.isVisible) {
      // シェーマのタブは開く頻度低いはずなので、不必要にapiを叩かないように抑制している
      this.initialize();
    }
  }

  @Prop()
  department: Department;

  @Prop()
  isVisible: boolean;

  @Watch("isVisible")
  onIsVisibleUpdated(newValue: boolean, oldValue: boolean): void {
    if (newValue && !this.isInitialized) {
      this.initialize();
    }
  }

  initialize(): void {
    this.selectedDepartment = this.department;
    this.isInitialized = true;
  }

  get schemaName(): string {
    return this.$configuration.behavior.collaboration.schema.imageName;
  }

  @Watch("selectedDepartment")
  onSelectedDepartmentChanged(newValue: Department, oldValue: Department): void {
    this.findClaioSchemas(newValue);
  }

  @Watch("selectedGroup")
  onSelectedGroupChanged(newValue: ClaioSchemaGroup, oldValue: ClaioSchemaGroup): void {
    this.editingSource = !!newValue ? newValue.items : [];
  }

  findClaioSchemas(department: Department): void {
    this.selectedGroup = null;
    this.groups = null;
    this.editingSource = [];

    if (!department) {
      this.groups = [];
      return;
    }
    const repository = DomainRegistry.claio.getClaioRepository();
    repository.getClaioSchemaGroups(department.id)
    .then(groups => {
      if (!groups) { return; }
      this.selectedGroup = (groups.length !== 0) ? groups[0] : null;
      this.groups = groups.map(d => new StandardOption(d.name, d));
    })
    .catch(e => {
      this.$error(
        this.schemaName + "検索失敗",
        this.schemaName + "検索失敗しました。",
        e,
      );
    });
  }

  get departmentGroup(): DepartmentGroup {
    return this.$configuration.behavior.document.editor.departmentGroup.shouldIgnoreDepartmentGroupFilter ? null : undefined;
  }
}
